import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

type FilterSearchUrl = { id: string; search: string };
type FilterResolveUrl = { id: string };

const requests = {
    filterSearch: (config: AxiosRequestConfig, url: FilterSearchUrl) =>
        api.get(
            `/table-management/filters/${url.id}/search/${encodeURIComponent(
                url.search,
            )}`,
            config,
        ),
    filterResolve: (config: AxiosRequestConfig, url: FilterResolveUrl) =>
        api.get(`/table-management/filters/${url.id}/resolve`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/table-management/${url.id}`, config),
    delete: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/table-management/${url.id}`, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/table-management/${url.id}`, data, config),
};

export default requests;
